/**
 * 이용약관·개인정보처리방침 본문 상수.
 * CMS가 없어 코드에 하드코딩되어 있다. 약관 본문 수정은 PR + 배포가 필요하다.
 * pages/signin, modal/PolicyModal 등에서 사용한다.
 */
const TERMS_OF_SERVICE: string = `제 1 조 (목적)
이 약관은 코드하나법인 주식회사 코드하나(이하 “코드하나“)가 제공하는 온라인 소프트웨어 교육 플랫폼인 해봄 서비스(이하 “해봄“) 및 해봄과 관련한 제반 서비스의 이용과 관련하여 코드하나과 회원과의 권리, 의무 및 책임사항, 기타 필요한 사항을 규정함을 목적으로 합니다.\n
제 2 조 (정의)
이 약관에서 사용하는 용어의 정의는 다음과 같습니다.
① “서비스“라 함은 구현되는 단말기(PC, TV, 휴대형단말기 등의 각종 유무선 장치를 포함)와 상관없이 회원이 이용할 수 있는 해봄 및 해봄과 관련 제반 서비스를 의미합니다.
② “회원“이라 함은 코드하나의 서비스에 접속하여 이 약관에 동의하고 코드하나과 이용계약을 체결하여 코드하나가 제공하는 서비스를 이용하는 고객을 말합니다.
③ “아이디(ID)“이라 함은 회원의 식별과 서비스 이용을 위하여 회원이 정하고 코드하나가 승인하는 문자와 숫자의 조합을 의미합니다.
④ “비밀번호“라 함은 회원이 부여받은 아이디(ID)와 일치되는 회원임을 확인하고 비밀보호를 위해 회원 자신이 정한 문자 또는 숫자의 조합을 의미합니다.
⑤ “게시물“이라 함은 회원이 서비스를 이용함에 있어 서비스에 게시ㆍ게재ㆍ등록한 부호ㆍ문자ㆍ음성ㆍ음향ㆍ화상ㆍ동영상 등의 정보 형태의 글, 사진, 동영상 및 각종 파일과 링크 등을 의미하며, 서비스의 작품, 스터디, 스터디모음 및 댓글, 커뮤니티 게시물 및 댓글 등을 통칭합니다.\n
제 3 조 (약관의 게시와 개정)
① 코드하나는 이 약관의 내용을 회원이 쉽게 알 수 있도록 서비스 초기 화면에 게시합니다.
② 코드하나는 “약관의규제에관한법률“, “정보통신망이용촉진및정보보호등에관한법률(이하 “정보통신망법“)” 등 관계법령을 위배하지 않는 범위에서 이 약관을 개정할 수 있습니다.
③ 코드하나가 약관을 개정할 경우에는 적용일자 및 개정사유를 명시하여 현행약관과 함께 제1항의 방식에 따라 그 개정약관의 적용일자 7일 전부터 적용일자 전일까지 공지합니다. 다만, 회원에게 불리한 약관의 개정의 경우에는 최소 30일 전에 공지하고 로그인시 동의창 등의 전자적 수단을 통해 개별적으로 명확히 통지하도록 합니다.
④ 코드하나가 전항에 따라 개정약관을 공지 또는 통지하면서 회원에게 위 기간 내에 의사표시를 하지 않으면 의사표시가 표명된 것으로 본다는 뜻을 명확하게 공지 또는 통지하였음에도 회원이 명시적으로 거부의 의사표시를 하지 아니한 경우 회원이 개정약관에 동의한 것으로 봅니다.
⑤ 회원이 개정약관의 적용에 동의하지 않는 경우 코드하나는 개정 약관의 내용을 적용할 수 없으며, 이 경우 회원은 이용계약을 해지할 수 있습니다. 다만, 기존 약관을 적용할 수 없는 특별한 사정이 있는 경우에는 코드하나는 이용계약을 해지할 수 있습니다.\n
제 4 조 (약관의 해석)
① 코드하나는 서비스의 원활한 제공을 위하여 별도의 운영 정책을 둘 수 있으며, 이 약관에서 정하지 아니한 사항이나 해석에 대해서는 운영 정책, 관계법령 또는 상관례에 따릅니다.
② 코드하나는 서비스 중 특정 서비스에 관한 약관(이하 “개별약관“)을 별도로 제정할 수 있으며, 회원이 개별약관에 동의한 경우 개별약관은 이용계약의 일부를 구성하고 개별약관에 이 약관과 상충하는 내용이 있을 경우 개별약관이 우선적으로 적용됩니다.\n
제 5 조 (이용계약 체결)
① 이용계약은 회원이 되고자 하는 자(이하 “가입신청자“)가 약관의 내용에 대하여 동의를 한 다음 회원가입신청을 하고 코드하나가 이러한 신청에 대하여 승낙함으로써 체결됩니다.
② 코드하나는 “가입신청자“의 신청에 대하여 서비스 이용을 승낙함을 원칙으로 합니다. 다만, 코드하나는 다음 각 호에 해당하는 신청에 대하여는 승낙을 하지 않거나 사후에 이용계약을 해지할 수 있습니다.
1. 가입신청자가 이 약관에 의하여 이전에 회원자격을 상실한 적이 있는 경우, 단 코드하나의 회원 재가입 승낙을 얻은 경우에는 예외로 함.
2. 허위의 정보를 기재하거나, 코드하나가 제시하는 내용을 기재하지 않은 경우
3. “가입신청자“의 귀책사유로 인하여 승인이 불가능하거나 기타 규정한 제반 사항을 위반하며 신청하는 경우
③ 제1항에 따른 신청에 있어 코드하나는 회원의 종류에 따라 전문기관을 통한 실명확인 및 본인인증을 요청할 수 있습니다.
④ 코드하나는 서비스관련설비의 여유가 없거나, 기술상 또는 업무상 문제가 있는 경우에는 승낙을 유보할 수 있습니다.
⑤ 제2항과 제4항에 따라 회원가입신청의 승낙을 하지 아니하거나 유보한 경우, 코드하나는 원칙적으로 이를 가입신청자에게 알리도록 합니다.
⑥ 이용계약의 성립 시기는 코드하나가 가입완료를 신청절차 상에서 표시한 시점으로 합니다.
⑦ 코드하나는 운영 정책에 따라 회원을 등급별로 구분하여 이용시간, 이용횟수, 서비스 메뉴 등을 세분하여 이용에 차등을 둘 수 있습니다.
⑧ 코드하나는 회원에 대하여 “영화및비디오물의진흥에관한법률” 및 “청소년보호법“등에 따른 등급 및 연령 준수를 위해 이용제한이나 등급별 제한을 할 수 있습니다.\n
제 6 조 (회원정보의 변경)
① 회원은 회원정보관리화면을 통하여 언제든지 본인의 회원정보를 열람하고 수정할 수 있습니다. 다만, 서비스 관리를 위해 필요한 아이디(ID) 등은 수정이 불가능합니다.
② 회원은 회원가입 신청 시 기재한 사항이 변경되었을 경우 서비스 내 회원정보관리화면에서 수정을 하거나 전자우편 기타 방법으로 코드하나에 대하여 그 변경사항을 알려야 합니다.
③ 제2항의 변경사항을 코드하나에 알리지 않아 발생한 불이익에 대하여 코드하나는 책임지지 않습니다.\n
제 7 조 (개인정보보호 의무)
코드하나는 정보통신망법 등 관계 법령이 정하는 바에 따라 회원의 개인정보를 보호하기 위해 노력합니다. 개인정보의 보호 및 사용에 대해서는 관계법령 및 코드하나의 개인정보 처리방침이 적용됩니다. 다만, 코드하나가 운영하는 서비스의 공식 사이트 이외의 사이트에서 링크된 제3자의 사이트에서는 코드하나의 개인정보 처리방침이 적용되지 않습니다.\n
제 8 조 (회원의 아이디(ID) 및 비밀번호의 관리에 대한 의무)
① 회원의 아이디(ID)와 비밀번호에 관한 관리책임은 회원에게 있으며, 이를 제 3자가 이용하도록 하여서는 안 됩니다.
② 코드하나는 회원의 아이디(ID)가 개인정보 유출 우려가 있거나, 반사회적 또는 미풍양속에 어긋나거나 코드하나 및 코드하나의 운영자로 오인할 우려가 있는 경우, 해당 아이디(ID)의 이용을 제한할 수 있습니다.
③ 회원은 아이디(ID) 및 비밀번호가 도용되거나 제3자가 사용하고 있음을 인지한 경우에는 이를 즉시 코드하나에 통지하고 코드하나의 안내에 따라야 합니다.
④ 제3항의 경우에 해당 회원이 코드하나에 그 사실을 통지하지 않거나, 통지한 경우에도 코드하나의 안내에 따르지 않아 발생한 불이익에 대하여 코드하나는 책임지지 않습니다.\n
제 9 조 (회원에 대한 통지)
① 코드하나가 회원에 대한 통지를 하는 경우 이 약관에 별도 규정이 없는 한 로그인 시 공지 창, 서비스 화면 또는 전자우편 등을 통해 통지할 수 있습니다.
② 코드하나는 회원 전체에 대해 통지의 경우 7일 이상 코드하나의 공지사항에 게시함으로써 제1항의 통지에 갈음할 수 있습니다.\n
제 10 조 (코드하나의 의무)
① 코드하나는 관계법령과 이 약관이 금지하거나 미풍양속에 반하는 행위를 하지 않으며, 계속적이고 안정적으로 서비스를 제공하기 위하여 최선을 다하여 노력합니다.
② 코드하나는 회원이 안전하게 서비스를 이용할 수 있도록 개인정보보호를 위해 보안시스템을 갖추어야 하며 개인정보 처리방침을 공시하고 준수합니다.
③ 코드하나는 서비스이용과 관련하여 발생하는 회원의 불만 또는 피해구제요청을 적절하게 처리할 수 있도록 필요한 인력 및 시스템을 구비합니다.
④ 코드하나는 서비스이용과 관련하여 회원으로부터 제기된 의견이나 불만이 정당하다고 인정할 경우에는 이를 처리하여야 합니다. 회원이 제기한 의견이나 불만사항에 대해서는 게시판을 활용하거나 전자우편 등을 통하여 회원에게 처리과정 및 결과를 전달합니다.\n
제 11 조 (회원의 의무)
① 회원은 다음 행위를 하여서는 안 됩니다.
1. 신청 또는 변경 시 허위내용의 등록
2. 타인의 정보도용
3. 코드하나가 게시한 정보의 변경
4. 코드하나가 정한 정보 이외의 정보(컴퓨터 프로그램 등) 등의 송신 또는 게시
5. 코드하나 또는 제3자의 저작권 등 지적재산권에 대한 침해
6. 코드하나 또는 제3자의 명예를 손상시키거나 업무를 방해하는 행위
7. 외설 또는 폭력적인 메시지, 화상, 음성, 기타 공서양속에 반하는 정보를 서비스에 공개 또는 게시하는 행위
8. 코드하나의 동의 없이 영리를 목적으로 서비스를 사용하는 행위
9. 기타 불법적이거나 부당한 행위
② 회원은 관계법령, 이 약관의 규정, 이용정책, 이용안내 및 서비스와 관련하여 공지한 주의사항, 코드하나가 통지하는 사항 등을 준수하여야 하며, 기타 코드하나의 업무에 방해되는 행위를 하여서는 안 됩니다.\n
제 12 조 (서비스의 제공 등)
① 코드하나는 회원에게 아래와 같은 서비스를 제공합니다.
1. 프로그래밍 교육 서비스
2. 프로그래밍 제작 플랫폼
3. 프로그래밍 관련 저작물 공유 플랫폼
4. 프로그래밍 교육 관련 커뮤니티
5. 기타 코드하나가 추가 개발하거나 다른 회사와의 제휴 계약 등을 통해 회원에게 제공하는 일체의 서비스
② 코드하나는 서비스를 일정 범위로 분할하여 각 범위 별로 이용가능시간을 별도로 지정할 수 있습니다. 다만, 이러한 경우에는 그 내용을 사전에 공지합니다.
③ 서비스는 연중무휴, 1일 24시간 제공함을 원칙으로 합니다.
④ 코드하나는 컴퓨터 등 정보통신설비의 보수점검, 교체 및 고장, 통신두절 또는 운영상 상당한 이유가 있는 경우 서비스의 제공을 일시적으로 중단할 수 있습니다. 이 경우 코드하나는 제9조에서 정한 방법으로 회원에게 통지합니다. 다만, 코드하나가 사전에 통지할 수 없는 부득이한 사유가 있는 경우 사후에 통지할 수 있습니다.
⑤ 코드하나는 서비스의 제공에 필요한 경우 정기점검을 실시할 수 있으며, 정기점검시간은 서비스 초기 화면에 공지한 바에 따릅니다.\n
제 13 조 (서비스의 변경)
① 코드하나는 상당한 이유가 있는 경우에 운영상, 기술상의 필요에 따라 제공하고 있는 전부 또는 일부 서비스를 변경할 수 있습니다.
② 서비스의 내용, 이용방법, 이용시간에 대하여 변경이 있는 경우에는 변경사유, 변경될 서비스의 내용 및 제공일자 등은 그 변경 전에 해당 서비스 초기화면에 게시하여야 합니다.
③ 코드하나는 무료로 제공되는 서비스의 일부 또는 전부를 코드하나의 정책 및 운영의 필요상 수정, 중단, 변경할 수 있으며, 이에 대하여 관계법령에 특별한 규정이 없는 한 회원에게 별도의 보상을 하지 않습니다.\n
제 14 조 (정보의 제공 및 광고의 게재)
① 코드하나는 정보통신망법 제50조 소정의 영리목적의 광고성 정보를 제외하고는 회원이 서비스 이용 중 필요하다고 인정되는 다양한 정보를 공지사항이나 전자우편 등의 방법으로 회원에게 제공할 수 있습니다. 다만, 회원은 관계법령에 따른 거래관련 정보 및 고객문의 등에 대한 답변 등을 제외하고는 언제든지 전자우편에 대해서 수신 거절을 할 수 있습니다.
② 제1항의 정보를 전화 및 모사전송기기에 의하여 전송하려고 하는 경우에는 회원의 사전 동의를 받아서 전송합니다. 다만, 회원의 서비스 이용 관련 주요 정보 및 고객문의 등에 대한 회신에 있어서는 제외됩니다.
③ 코드하나는 서비스의 운영과 관련하여 서비스 화면, 홈페이지 등에 광고를 게재할 수 있습니다.
④ “이용자(회원, 비회원 포함)“는 코드하나가 제공하는 서비스와 관련하여 게시물 또는 기타 정보를 변경, 수정, 제한하는 등의 조치를 취하지 않습니다.\n
제 15 조 (게시물의 저작권)
① 회원이 서비스 내에 게시한 게시물의 저작권은 해당 게시물의 저작자에게 귀속됩니다.
② 회원은 본인이 작성한 게시물을 서비스 내에 공개할 경우 다음 각 호의 사항을 허락하며, 구체적인 내용은 해봄 저작권 정책에 따릅니다.
1. 내가 만든 게시물과 그 소스 코드를 공개하는 것에 동의합니다.
2. 다른 사람이 나의 게시물을 이용하는 것을 허락합니다. (비영리 목적의 복제, 공중송신, 배포 등을 포함)
3. 다른 사람이 나의 게시물을 수정하는 것을 허락합니다. (리메이크, 변형 등 2차적 저작물 작성을 포함)
③ 코드하나는 회원이 서비스 내에 게시하는 게시물을 서비스 내 노출, 서비스 홍보를 위한 활용, 서비스 운영, 개선 및 새로운 서비스 개발을 위한 연구, 웹 접근성 등 법률상 의무 준수, 외부 사이트에서의 검색, 수집 및 링크 허용 등을 위해서 사용할 수 있으며, 회원은 코드하나의 해당 사용을 위해 필요한 범위 내에서 회원의 게시물을 저장, 수정, 복제, 편집, 공중 송신, 전시, 배포, 2차적 저작물 작성 등의 이용권한을 코드하나에게 부여합니다(기한과 지역 제한에 정함이 없으며, 별도 대가 지급이 없는 라이선스). 코드하나는 회원의 저작물을 이용함에 있어 저작권법 규정을 준수하며, 회원은 언제든지 고객센터 또는 서비스 내 관리기능을 통해 해당 게시물에 대해 삭제, 비공개 등의 조치를 취할 수 있습니다.
④ 코드하나는 제3항에서 명시된 것 이외의 목적과 방법으로 회원의 게시물을 이용하고자 하는 경우에는 전화, 팩스, 전자우편 등을 통해 사전에 회원의 동의를 얻어야 합니다.\n
제 16 조 (게시물의 관리)
① 회원의 게시물이 정보통신망법 및 저작권법등 관계법령에 위반되는 내용을 포함하는 경우, 권리자는 관계법령이 정한 절차에 따라 해당 게시물의 게시중단 및 삭제 등을 요청할 수 있으며, 코드하나는 관계법령에 따라 조치를 취하여야 합니다.
② 코드하나는 전항에 따른 권리자의 요청이 없는 경우라도 권리침해가 인정될 만한 사유가 있거나 기타 운영 정책 및 관계법령에 위반되는 경우에는 관계법령에 따라 해당 게시물에 대해 임시조치 등을 취할 수 있습니다.\n
제 17 조 (권리의 귀속)
① 서비스에 대한 저작권 및 지적재산권은 코드하나에 귀속됩니다. 단, 회원의 게시물 및 제휴계약에 따라 제공된 저작물 등은 제외합니다.
② 코드하나는 서비스와 관련하여 회원에게 코드하나가 정한 이용조건에 따라 계정, 콘텐츠 등을 이용할 수 있는 이용권한만을 부여하며, 회원은 이를 양도, 판매, 담보제공 등의 처분행위를 할 수 없습니다.\n
제 18 조 (계약해제, 해지 등)
① 회원은 언제든지 서비스 초기화면의 고객센터 또는 내 정보 관리 메뉴 등을 통하여 이용계약 해지 신청을 할 수 있으며, 코드하나는 관계법령 등이 정하는 바에 따라 이를 즉시 처리하여야 합니다.
② 회원이 계약을 해지할 경우, 관계법령 및 개인정보 처리방침에 따라 코드하나가 회원정보를 보유하는 경우를 제외하고는 해지 즉시 회원의 모든 데이터는 소멸됩니다.
③ 회원이 계약을 해지하는 경우, 회원이 작성한 게시물 중 작품, 스터디, 스터디모음 등과 같이 본인 계정에 등록된 게시물 일체는 삭제됩니다. 다만, 공용게시판에 등록된 게시물, 공유 등이 되어 재게시된 게시물은 삭제되지 않으니, 직접 삭제 또는 코드하나에 삭제 요청을 통하여 사전에 삭제 후 탈퇴해야 합니다.
④ 전항과 관련하여 회원이 저작자가 아니거나 타인이 공동으로 권리를 보유한 게시물의 경우 삭제되지 않을 수 있습니다.\n
제 19 조 (이용제한 등)
① 코드하나는 회원이 이 약관의 의무를 위반하거나 서비스의 정상적인 운영을 방해한 경우, 경고, 일시정지, 영구이용정지 등으로 서비스 이용을 단계적으로 제한할 수 있습니다.
② 코드하나는 전항에도 불구하고, 결제도용, 저작권법 등 관계법령을 위반한 불법프로그램의 제공 및 운영방해, 정보통신망법을 위반한 불법통신 및 해킹, 악성프로그램의 배포, 접속권한 초과행위 등과 같이 관계법령을 위반한 경우에는 즉시 영구이용정지를 할 수 있습니다. 본 항에 따른 영구이용정지 시 회원에게 제공되는 서비스 이용권한 등은 모두 소멸되며, 코드하나는 이에 대해 별도로 보상하지 않습니다.
③ 코드하나는 회원이 계속해서 3개월 이상 로그인하지 않는 경우, 회원정보의 보호 및 운영의 효율성을 위해 이용을 제한할 수 있습니다.
④ 코드하나는 본 조의 이용제한 범위 내에서 제한의 조건 및 세부내용은 이용정책에서 정하는 바에 의합니다.
⑤ 본 조에 따라 서비스 이용을 제한하거나 계약을 해지하는 경우에는 코드하나는 제9조에서 정한 방법에 따라 통지합니다.
⑥ 회원은 본 조에 따른 이용제한 등에 대해 코드하나가 정한 절차에 따라 이의신청을 할 수 있습니다. 이 때 이의가 정당하다고 코드하나가 인정하는 경우 코드하나는 즉시 서비스의 이용을 재개합니다.\n
제 20 조 (책임제한)
① 코드하나는 천재지변 또는 이에 준하는 불가항력으로 인하여 서비스를 제공할 수 없는 경우에는 서비스 제공에 관한 책임이 면제됩니다.
② 코드하나는 회원의 귀책사유로 인한 서비스 이용의 장애에 대하여는 책임을 지지 않습니다.
③ 코드하나는 회원이 서비스와 관련하여 게재한 정보, 자료, 사실의 신뢰도, 정확성 등의 내용에 관하여는 책임을 지지 않습니다.
④ 코드하나는 회원 간 또는 회원과 제3자 상호 간에 서비스를 매개로 하여 거래 등을 한 경우에 해당 거래 등과 관련하여 책임을 지지 않습니다.
⑤ 코드하나는 무료로 제공되는 서비스 이용과 관련하여 관계법령에 특별한 규정이 없는 한 책임을 지지 않습니다.\n
제 21 조 (준거법 및 재판관할)
① 코드하나과 회원 간 제기된 소송은 대한민국법을 준거법으로 합니다.
② 코드하나과 회원 간 발생한 분쟁에 관한 소송은 제소 당시의 회원의 주소에 의하고, 주소가 없는 경우 거소를 관할하는 지방법원의 전속관할로 합니다. 단, 제소 당시 회원의 주소 또는 거소가 명확하지 아니한 경우의 관할법원은 민사소송법에 따라 정합니다.
③ 해외에 주소나 거소가 있는 회원의 경우 코드하나과 회원간 발생한 분쟁에 관한 소송은 전항에도 불구하고 대한민국 서울중앙지방법원을 관할법원으로 합니다.
부칙
1. 이 약관은 2024년 9월 23일부터 적용됩니다.
- 공고일자: 2024년 9월 15일
- 시행일자: 2024년 9월 23일
`;

const PRIVACY_POLICY: string = `개인정보처리방침 (해봄)

코드하나(이하 "회사")는 「개인정보 보호법」 등 관련 법령을 준수하며, 이용자의 개인정보를 보호하기 위하여 다음과 같은 개인정보처리방침을 수립·공개합니다. 본 방침은 회사가 제공하는 교육 플랫폼 해봄(웹) 서비스에 적용됩니다.

본 개인정보처리방침은 2026년 3월 9일부터 적용됩니다. 


1. 개인정보의 처리 목적

회사는 본 서비스 운영과 관련하여 다음의 목적을 위하여 개인정보를 처리할 수 있습니다. 처리한 개인정보는 아래 목적 이외의 용도로 이용되지 않으며, 목적이 변경되는 경우 변경 내용을 이용자에게 사전 고지하고 개인정보 보호법 제18조에 따라 별도의 동의를 받습니다.

1) 학생 회원관리 및 서비스 제공
    - 가입 의사 확인, 계정 생성 및 로그인, 서비스 제공 및 운영, 이용자 식별
    - 고객 문의/상담 처리, 서비스 내 공지 전달
    - 리포트 생성/관리, 멤버(학생) 관리, 과제/퀴즈/챕터/ 기록 관리 등 서비스 기능 제공
2) 학습 역량 분석 및 리포트 제공
    - 문항 응답과 답안을 바탕으로 한 역량 분석, 학습 성향과 강약점 프로파일 생성 및 리포트 제공
    - 위 분석 결과는 교육 목적으로만 이용하며, 광고 대상 선별이나 교육 외의 용도로 이용하지 않습니다.
3) 서비스 품질 개선 및 보안
    - 오류 확인, 안정성 확보, 부정 이용 방지
    - 보안 이벤트 대응 및 로그 분석(필요 범위)


2. 개인정보의 수집 방법

회사는 아래와 같은 방법으로 개인정보를 수집할 수 있습니다.

- 학생 회원가입/로그인 과정에서 직접 입력
- 가정통신문으로 고지 후 학교 관리에 따라 학생 정보를 전달받아 내부 개인정보책임자가 직접 입력
- 고객 문의(이메일) 과정에서 이용자가 제공하는 정보
- 서비스 이용 과정에서 자동 생성·수집되는 정보(접속 로그 등)


3. 처리하는 개인정보 항목 (최소수집 원칙)

회사는 서비스 제공에 필요한 최소한의 개인정보만 처리하며, 목적 달성에 불필요한 개인정보는 수집하지 않습니다. 회사는 원칙적으로 주민등록번호 등 고유식별정보와 건강정보 등 민감정보를 수집·저장하지 않으며, 카드번호 등 결제수단 정보도 수집하지 않습니다.

3-1) 멤버(학생/학부모)

멤버(학생)은 회원가입 또는 관리자 회원가입 대행을 통해 계정을 전달받고 길잡이별 검사 서비스를 이용합니다. 회사는 멤버(학생) 개인정보를 최소화하며, 서비스 운영을 위해 다음 정보가 서비스 내에 저장·이용될 수 있습니다. 각 항목은 필수와 선택으로 구분하며, 선택 항목을 입력하지 않아도 서비스를 이용할 수 있습니다.

[필수 항목]
- 아이디, 비밀번호: 계정 식별 및 로그인
- 이름: 학습 리포트 표기, 교사 반 명단 매칭
- 휴대전화번호: 본인인증, 계정 복구
- 생년월일: 만 14세 미만 여부 판별, 학습 리포트 표기
- 학교, 학년, 반, 번호(출석번호 등): 반 명단 매칭, 학년별 문항 제공
- 이메일: 계정 복구, 서비스 안내 발송

[선택 항목]
- 성별: 학습 리포트 표기, 통계 분석
- 주소(우편번호, 주소, 상세주소): 교재 발송 시 이용

[자동 생성·수집 항목]
- 학습/활동 기록: 챕터 제출 상태, 학생별 문제 응답(정답/선택/응답 결과 등), 응답에 따른 리포트
- 서비스 이용 동의서 파일: 가정통신문으로 직접 승인 받은 서비스 이용 동의서(관리자 대행 가입 시)

회사는 수집 항목과 그 목적의 적정성을 최소 연 1회 검토하며, 목적 달성에 더 이상 필요하지 않은 항목은 수집을 중단합니다.

3-2) 스토리지(이미지 업로드) 관련

회사는 AWS(아마존 웹 서비스)를 이용하며, 현재는 이용자의 서비스 이용 동의서 업로드를 위해서만 사용합니다. 회사는 해당 이미지가 외부에 노출되지 않도록 운영합니다.

3-3) 서비스 이용 과정에서 자동 생성·수집될 수 있는 항목

서비스 제공 및 보안, 부정 이용 방지 등을 위해 아래 정보가 자동 생성·수집될 수 있습니다.

- 접속 IP 주소, 접속일시, 서비스 이용기록, 기기/브라우저 정보, 오류 기록


4. 개인정보의 처리 및 보유 기간

회사는 개인정보 보유기간의 경과, 처리 목적 달성 등 개인정보가 불필요하게 되었을 때 지체 없이 파기합니다. 파기는 개인정보를 복구할 수 없는 방법으로 삭제하거나, 특정 개인을 알아볼 수 없도록 비식별 처리하는 방식으로 합니다.

1) 학생/법정대리인 개인정보
    - 회원 탈퇴 시까지 보관하며, 탈퇴 후 부정 이용 방지 및 분쟁 대응을 위해 최대 1년간 보관한 뒤 파기
    - 단, 관계 법령에 따라 보존이 필요한 경우 해당 법령이 정한 기간 동안 다른 개인정보와 분리하여 보관
2) 학습데이터(문제 응답, 챕터 제출 상태, 리포트 등 서비스 운영 데이터)
    - 회원 탈퇴 시 개인을 알아볼 수 없도록 비식별 처리한 뒤, 리포트 고도화·통계 목적으로만 활용
    - 탈퇴하지 않은 계정이라도 마지막 서비스 이용일로부터 2년이 경과하면 동일하게 비식별 처리
3) 서비스 이용 과정에서 자동 수집된 정보(접속 기록 등)
    - 개인정보처리시스템 접속 기록: 「개인정보의 안전성 확보조치 기준」에 따라 1년 이상 보관 후 파기
    - 그 외 오류 기록·기기 정보: 수집일로부터 1년 보관 후 파기


5. 만 14세 미만 이용자 관련 안내(아동 개인정보 보호)

해봄은 학교 수업과 함께 쓰이는 교육 서비스로, 이용자 대부분이 초·중·고 학생입니다. 학생의 개인정보와 학습 기록은 본인의 학습 이력이자 성장 과정을 담은 정보이므로, 회사는 이를 성인 이용자의 정보보다 더 엄격하게 다루어야 할 대상으로 봅니다. 이에 회사는 다음을 원칙으로 삼습니다.

- 수업 운영과 학습 결과 제공에 꼭 필요한 정보만 수집하고, 그 밖의 정보는 요구하지 않습니다.
- 학생의 정보를 판매하거나 대여하지 않으며, 학생을 대상으로 하는 광고에 이용하지 않습니다.
- 학교와 보호자가 승인한 범위를 넘어 학생 정보를 이용하거나 제3자에게 제공하지 않습니다.
- 학습이 끝나 더 이상 필요하지 않게 된 정보는 제4조에서 정한 보유기간이 지나면 파기하거나 개인을 알아볼 수 없도록 처리합니다.
- 학생 정보를 다루는 담당자를 최소한으로 두고, 처리 현황을 정기적으로 점검합니다.

회사는 멤버(학생)의 연령에 따라 법정대리인 동의를 직접 가정통신문으로 받는 이용 구조로 서비스를 제공하며, 멤버(학생) 정보는 관리자가 검사 운영 목적에서 이름/번호 및 학습·활동 기록 수준으로 입력·관리합니다. 회사는 서비스 이용 과정에서 주민등록번호 등 고유식별정보와 건강정보 등 민감정보의 입력을 요구하지 않으며, 제3조에 명시한 항목 외의 개인정보를 수집하지 않습니다.

회사는 만 14세 미만 아동의 개인정보를 광고성 정보 발송이나 맞춤형 광고 대상 선별에 이용하지 않습니다.

법정대리인이 멤버(학생) 정보의 열람·정정·삭제 등을 요청하는 경우, 해당 정보가 관리자에 의해 입력·관리되는 구조임을 고려하여 관리자를 통해 우선 처리될 수 있으며, 필요 시 회사 문의처를 통해 지원을 요청할 수 있습니다.


6. 개인정보의 제3자 제공

회사는 원칙적으로 이용자의 개인정보를 명시한 범위 내에서만 처리·이용하며, 아래에 해당하는 경우 외에는 개인정보를 제3자에게 제공하지 않습니다.

6-1) 서비스 운영을 위한 제공 현황

가. 소속 학교의 담당 교사
    - 제공 목적: 수업 운영, 학습 참여 및 진도 확인, 학습 결과 상담
    - 제공 항목: 이름, 학년·반·번호, 로그인 계정, 학습 진행 상황 및 리포트
    - 보유·이용 기간: 해당 학급 운영 종료 시 또는 학생 계정 이용 종료 시까지

나. 멤버(학생)의 법정대리인(보호자)
    - 제공 목적: 자녀의 학습 결과 확인
    - 제공 항목: 이름, 학년·반·번호, 역량 리포트
    - 보유·이용 기간: 학습 결과 공유 링크의 유효기간(발급일로부터 14일)

6-2) 이용자의 동의 없이 제공할 수 있는 경우

다음의 경우에는 「개인정보 보호법」 제18조 제2항에 따라 이용자의 동의 없이 개인정보를 제공할 수 있습니다.

- 교육부·시도교육청 등 관계 기관이 법령에 따른 교육행정 또는 감사 업무 수행을 위하여 요구하는 경우
- 수사기관이 「형사소송법」 등 법령에 근거한 적법한 절차(영장 등)에 따라 요구하는 경우
- 그 밖에 법령에 제공 의무가 규정되어 있는 경우

회사는 위 제공 현황이 실제 처리 현황과 일치하는지 최소 연 1회 검토하며, 변경 사항이 있는 경우 본 방침에 반영합니다.

6-3) 영업의 양도·합병 등에 따른 개인정보 이전

회사는 영업의 전부 또는 일부를 양도하거나 합병하는 경우, 「개인정보 보호법」 제27조에 따라 그 사실과 이전받는 자의 정보, 이용자가 개인정보 이전을 원하지 않을 때의 조치 방법을 사전에 알려드립니다. 이전받는 자가 본 방침과 같은 수준의 보호 의무를 승계하여 준수하는 경우에만 개인정보를 이전합니다.


7. 개인정보 처리의 위탁 및 데이터 저장 위치 안내

회사는 원활한 서비스 제공을 위해 다음과 같이 개인정보 처리 업무를 위탁하며, 위탁 시 관련 법령에 따라 수탁자가 개인정보를 안전하게 처리하도록 관리·감독합니다.

7-1) 본인확인 서비스(포트원)

- 수탁자: 포트원(PortOne, 옛 아임포트)
- 위탁업무: 휴대전화 본인확인 및 인증 결과 조회

7-2) 클라우드/호스팅(AWS)

- 수탁자: Amazon Web Services, Inc. (AWS)
- 위탁업무: 서비스 운영 인프라 제공(서버/DB/호스팅), 데이터 보관 및 시스템 운영

7-3) 학습 리포트 채점 보조(외부 AI 서비스)

- 수탁자: Anthropic, PBC (Claude API). 회사가 채점 모델을 변경하는 경우 OpenAI, L.L.C. (OpenAI API)를 사용할 수 있으며, 두 수탁자 모두 전달 정보의 범위와 보호조치는 동일합니다.
- 위탁업무: 학생 답안과 학습 결과를 바탕으로 한 채점 보조, 학습 코멘트 및 리포트 문구 생성
- 전달 정보: 문항, 채점 기준, 학생 답안 본문, 역량 점수.
- 이름·연락처 등 학생을 식별할 수 있는 정보는 전달하지 않습니다.
- 회사는 위 정보를 수탁자의 AI 모델 학습 목적으로 제공하지 않습니다. 수탁자는 전달받은 정보를 채점 요청 처리 후 남용 방지·안전 확인 목적으로 최대 30일간 보관한 뒤 삭제합니다.

7-4) 데이터 저장 위치(리전)

회사는 서비스 운영을 위해 AWS(아마존 웹 서비스)를 사용하고 있으며, 이용자의 개인정보는 대한민국(서울 리전, ap-northeast-2)에 저장·보관됩니다. 다만 제7-3조의 채점 보조 처리는 수탁자가 운영하는 국외 인프라에서 이루어질 수 있으며, 이 경우 전달되는 정보의 범위와 보호조치는 제7-3조에 안내한 바와 같습니다. 회사는 관련 법령에 따라 필요한 보호조치를 적용하고, 변경 사항이 있는 경우 본 방침에 반영하여 안내합니다.


8. 개인정보의 파기 및 익명화 절차 및 방법

파기 및 익명화 절차: 수집한 개인정보 선정 → 내부 절차에 따른 확인 → 파기 및 익명화 실행

파기 및 익명화 방법

- 전자적 파일 형태: 복구 및 식별 불가능한 방법으로 영구 익명화
- 출력물: 분쇄 또는 소각


9. 정보주체의 권리·의무 및 행사 방법(절차 포함)

회원은 회사에 대해 언제든지 개인정보 열람, 정정·삭제, 처리정지, 동의 철회 등을 요구할 수 있습니다.

- 권리 행사는 아래 경로 중 편한 방법으로 신청할 수 있습니다.
    - 온라인: 서비스 내 문의하기 게시판
    - 이메일: edu@codehana.co.kr
    - 전화: 02-313-8910
    - 서면: 서울특별시 마포구 마포대로12 한신오피스텔 1012호 (개인정보 보호책임자 앞)
- 회사는 요청을 받은 날로부터 관련 법령이 정한 기간 내(열람·전송 요구는 통상 10일 이내, 정정·삭제·처리정지는 검토 후 지체 없이)에 조치하고 처리 결과를 안내합니다.
- 광고성 정보 수신 등 선택 항목에 대한 동의 철회도 위 경로로 신청할 수 있으며, 발송되는 광고성 정보에 표기된 수신거부 방법으로도 철회할 수 있습니다.
- 요청 내용 확인을 위해 필요한 경우 본인 확인을 위한 추가 정보를 요청할 수 있습니다.
- 법정대리인 또는 위임을 받은 대리인이 권리를 행사하는 경우, 회사는 위임장 및 관계 확인 서류 제출을 요청할 수 있습니다.
- 다만 관계 법령에 따라 보관 의무가 있는 정보는 해당 기간 동안 삭제가 제한될 수 있습니다.

멤버(학생) 정보는 관리자가 입력·관리하는 구조이므로, 멤버(학생) 정보 관련 요청은 관리자를 통해 처리될 수 있습니다.


10. 개인정보의 안전성 확보조치

회사는 개인정보 보호를 위해 다음과 같은 조치를 취합니다.

- 관리적 조치: 내부관리계획 수립, 접근 권한 최소화, 정기 점검, 임직원(해당 시) 교육
- 기술적 조치: 비밀번호 암호화 저장, 접근통제, 접근기록 관리, 전송구간 암호화(SSL/TLS 등), 보안 업데이트
- 운영적 조치: 주요 데이터 백업 및 복구 절차 운영, 침해사고 대응 절차(내부 보고, 차단, 조사, 재발방지) 운영
- 물리적 조치: 접근통제 등 필요한 보호조치(해당 시)


11. 인공지능(AI) 기술 활용 안내

회사는 학습 리포트의 채점과 코멘트 작성을 보조하기 위해 인공지능(AI) 기술을 활용합니다. 활용 범위와 이용자의 권리는 아래와 같습니다.

11-1) 활용 범위와 사람의 확인 절차

- 논서술형 문항 채점: AI가 채점 초안과 코멘트를 생성하고, 회사의 담당 연구진이 내용을 검토·확정한 뒤에만 이용자에게 공개됩니다. AI가 생성한 결과가 사람의 검토 없이 그대로 확정되지 않습니다.
- 객관식 문항 채점: 채점 결과를 바탕으로 한 리포트 총평 코멘트는 AI가 생성합니다.
- 학습 가이드 문구: 채점 결과를 바탕으로 한 학습 조언 문구는 AI가 자동으로 생성합니다.

11-2) AI 처리에 이용되는 정보와 결과의 관계

- 이용되는 정보: 학생이 작성한 답안 본문, 문항과 채점 기준, 문항별 응답 결과와 역량 점수
- 결과와의 관계: 답안 본문은 채점 기준과 대조되어 문항별 점수와 코멘트의 근거로 이용되고, 역량 점수는 학습 가이드 문구를 만드는 근거로 이용됩니다.
- 회사는 AI 처리 과정에서 이름·연락처 등 학생을 직접 식별할 수 있는 정보를 이용하지 않으며, 민감정보와 고유식별정보도 이용하지 않습니다.

11-3) 설명 요구 및 재검토 요청

- 이용자는 채점 결과나 AI가 생성한 코멘트에 대해 설명을 요구하거나 재검토를 요청할 수 있습니다.
- 요청은 제9조에 안내된 경로(문의하기 게시판, 이메일, 전화, 서면)로 접수할 수 있습니다.
- 회사는 요청을 받은 날부터 30일 이내에 필요한 조치를 하고 그 결과를 알려드리며, 요청을 받아들이지 않는 경우에는 10일 이내에 그 사유를 알려드립니다.
- AI가 생성한 코멘트에 부적절한 내용이 포함된 경우에도 같은 경로로 알려 주시면 확인 후 조치합니다.

12. 개인정보의 국외 이전

회사는 제7-3조의 학습 리포트 채점 보조를 위해 아래와 같이 개인정보를 국외로 이전합니다.

- 이전받는 자: Anthropic, PBC (Claude API). 채점 모델 변경 시 OpenAI, L.L.C. (OpenAI API)
- 이전되는 국가: 미국
- 이전 항목: 문항과 채점 기준, 학생이 작성한 답안 본문, 문항별 응답 결과와 역량 점수. 이름·연락처 등 학생을 직접 식별할 수 있는 정보는 이전하지 않습니다.
- 이전 목적: 채점 보조 및 학습 코멘트 생성
- 이전 일시 및 방법: 채점이 필요한 시점에 TLS로 암호화된 통신 구간을 통해 전송
- 보유 및 이용 기간: 수탁자는 채점 요청 처리 후 남용 방지·안전 확인 목적으로 최대 30일간 보관한 뒤 삭제합니다. 수탁자는 이전받은 정보를 AI 모델 학습에 이용하지 않습니다(Anthropic 상용 약관, OpenAI API 데이터 정책).
- 거부 방법 및 효과: 이용자는 제9조에 안내된 경로로 국외 이전을 거부할 수 있습니다. 다만 거부하는 경우 AI 채점 보조가 적용되는 논서술형 학습 리포트 제공이 제한될 수 있습니다.


13. 개인정보 침해 구제 방법

개인정보 침해에 대한 신고·상담이 필요하신 경우 아래 기관에 문의하실 수 있습니다.

- 개인정보침해신고센터: (국번없이) 118
- 개인정보분쟁조정위원회: (국번없이) 1833-6972
- 대검찰청 사이버범죄수사단: (국번없이) 1301
- 경찰청 사이버범죄 신고: (국번없이) 182


14. 개인정보 보호책임자 및 문의처

회사는 개인정보 관련 문의 및 불만처리 등을 위하여 아래와 같이 문의처를 운영합니다.

- 개인정보 보호책임자: 조하영 (직위: 대표)
- 담당 부서: 전략기획실
- 담당업무: 개인정보 보호 및 처리에 관한 업무 총괄, 권리 행사 요청 접수·처리
- 전화: 02-313-8910
- 이메일: edu@codehana.co.kr
- 주소: 서울특별시 마포구 마포대로12 한신오피스텔 1012호 (서면 접수처)


15. 개인정보처리방침의 변경

본 개인정보처리방침은 법령, 서비스, 내부 정책 변경에 따라 변경될 수 있으며, 변경 시 서비스 내 공지(팝업/공지 화면 등)를 통해 고지합니다. 회사는 개인정보처리방침을 개정하는 경우 최소 7일 전(중요한 변경의 경우 30일 전)부터 공지합니다.

- 공고일자: 2026년 3월 9일
- 시행일자: 2026년 3월 9일
`;

const MARKETING_CONSENT: string = `수신 동의를 하시면 다양한 정보를 받아보실 수 있습니다.
광고 수단 : SMS/E-Mail
`;

/**
 * 회원가입 동의 화면 전용 "개인정보 수집·이용 동의문".
 * 처리방침(PRIVACY_POLICY) 전문과 별개로, 개인정보 보호법 제15조 2항의 4고지
 * (수집 항목 / 이용 목적 / 보유 기간 / 동의 거부권과 불이익)만 요약한다.
 * 항목·목적은 PRIVACY_POLICY 3-1조와 반드시 일치시킬 것.
 */
const PRIVACY_CONSENT: string = `개인정보 수집·이용 동의 (해봄)

코드하나(이하 "회사")는 해봄 서비스 회원가입과 이용을 위해 아래와 같이 개인정보를 수집·이용합니다. 내용을 확인하신 뒤 동의 여부를 선택해 주세요.

1. 수집 항목과 이용 목적

[필수]
- 아이디, 비밀번호: 계정 식별 및 로그인
- 이름: 학습 리포트 표기, 교사 반 명단 매칭
- 휴대전화번호: 본인인증, 계정 복구
- 생년월일: 만 14세 미만 여부 판별, 학습 리포트 표기
- 학교, 학년, 반, 번호: 반 명단 매칭, 학년별 문항 제공
- 이메일: 계정 복구, 서비스 안내 발송

[선택]
- 성별: 학습 리포트 표기, 통계 분석
- 주소(우편번호, 주소, 상세주소): 교재 발송 시 이용

[서비스 이용 과정에서 자동 생성]
- 학습·활동 기록(문제 응답, 챕터 제출 상태, 리포트), 접속 IP·접속일시·기기 정보: 서비스 제공, 부정 이용 방지

2. 보유 및 이용 기간

- 회원 탈퇴 시까지 보유하며, 탈퇴 후 부정 이용 방지 및 분쟁 대응을 위해 최대 1년간 보관한 뒤 파기합니다.
- 단, 관계 법령에 따라 보존이 필요한 정보는 해당 법령이 정한 기간 동안 별도 보관합니다.

3. 동의를 거부할 권리와 불이익

- 귀하는 개인정보 수집·이용에 동의하지 않을 권리가 있습니다.
- 필수 항목 동의를 거부하시면 회원가입과 서비스 이용이 제한됩니다.
- 선택 항목은 동의하지 않아도 서비스 이용에 제한이 없습니다.

수집·이용 목적이 변경되는 경우 변경 내용을 사전에 알려드리고 별도로 동의를 받습니다. 자세한 내용은 개인정보처리방침(서비스 하단 링크)을 참고해 주세요.
`;

export { TERMS_OF_SERVICE, PRIVACY_POLICY, MARKETING_CONSENT, PRIVACY_CONSENT };
